import React, { createContext, useContext, useMemo } from 'react'
import { readBootFlags, FeatureFlags } from '@base/readBootFlags'

const FlagsContext = createContext<FeatureFlags>({} as FeatureFlags)

export function FlagsProvider({ children }: { children: React.ReactNode }) {
  const flags = useMemo(() => readBootFlags(), [])
  return <FlagsContext.Provider value={flags}>{children}</FlagsContext.Provider>
}

// Use this hook (in conjunction with a FlagsProvider) to check if a feature flag is enabled.
// Example: const isEnabled = useFlag('some_feature_flag')
export function useFlag(name: keyof FeatureFlags): boolean {
  const flags = useContext(FlagsContext)
  return Boolean(flags?.[name])
}
